import React from 'react';
import {
  Message,
  MessageContent,
} from '@cotera/client/v0/components/ai-elements/message';
import { cn } from '@cotera/client/v0/lib/utils';
import { useWatchableValue } from '@cotera/client/v0/actions/framework';
import { useCocoChatModel } from '../models/coco-chat.model';

const DOT_CLASS = cn(
  'inline-block w-1.5 h-1.5 rounded-full bg-muted-foreground/70',
  'animate-bounce'
);

const DOT_STYLE = { animationDuration: '1.8s' } as const;

/** Registered as the message footer id in `coco-chat.tsx` (`registerMessageFooter`). */
export const COCO_THINKING_MESSAGE_FOOTER_ID = 'coco-thinking' as const;

export const CocoThinkingPlaceholder: React.FC = () => {
  const model = useCocoChatModel();
  const cancelled = useWatchableValue(model.cancelledWatchable);
  if (cancelled) {
    return null;
  }
  return (
    <Message from="assistant">
      <MessageContent>
        <div className="flex items-center gap-1" aria-label="Coco is thinking">
          <span
            className={DOT_CLASS}
            style={{ ...DOT_STYLE, animationDelay: '0ms' }}
          />
          <span
            className={DOT_CLASS}
            style={{ ...DOT_STYLE, animationDelay: '300ms' }}
          />
          <span
            className={DOT_CLASS}
            style={{ ...DOT_STYLE, animationDelay: '600ms' }}
          />
        </div>
      </MessageContent>
    </Message>
  );
};
